import { c as _c } from "react/compiler-runtime";
import { addBlock, fetchBlockList, fetchBlockWordList, fetchCancelBlock } from '@module/apis/client-side/block';
import type { AddBlockParams, AddBlockResponse, BlockListParams, BlockWordListResponse, CancelBlockParams, FetchBlockListResponse } from '@module/apis/client-side/block/type';
import type { ApiBaseResponse } from '@module/apis/type';
import { type UseInfiniteQueryOptions, type UseMutationOptions, useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type { CustomUseQueryOptions } from '../type';
import { blockQueryKeys } from './blockQueryKeys';
export const useFetchBlockListQuery = (fetchBlockListParams, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== fetchBlockListParams) {
    t0 = blockQueryKeys.fetchBlockList(fetchBlockListParams);
    $[0] = fetchBlockListParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== fetchBlockListParams) {
    t1 = () => fetchBlockList(fetchBlockListParams);
    $[2] = fetchBlockListParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useQuery(t2);
};
export const useFetchBlockListInfiniteQuery = (params, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== params) {
    t0 = blockQueryKeys.fetchBlockList(params);
    $[0] = params;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== params) {
    t1 = t2 => {
      const {
        pageParam: t3
      } = t2;
      const pageParam = t3 === undefined ? 1 : t3;
      const actualPageParam = typeof pageParam === "number" ? pageParam : 1;
      const offset = params.limit * ((actualPageParam || 1) - 1);
      return fetchBlockList({
        ...params,
        offset
      });
    };
    $[2] = params;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== options || $[5] !== t0.queryKey || $[6] !== t1) {
    t2 = {
      initialPageParam: 1,
      queryKey: t0.queryKey,
      queryFn: t1,
      ...options,
      getNextPageParam: _temp2,
      select: _temp4
    };
    $[4] = options;
    $[5] = t0.queryKey;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return useInfiniteQuery(t2);
};
export const useCancelBlockMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = blockQueryKeys.fetchCancelBlock();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp5,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useAddBlockMutation = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = blockQueryKeys.fetchCancelBlock();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      mutationKey: t0.queryKey,
      mutationFn: _temp6,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useMutation(t1);
};
export const useFetchBlockWordListQuery = options => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = blockQueryKeys.fetchBlockWordList();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== options) {
    t1 = {
      queryKey: t0.queryKey,
      queryFn: _temp7,
      ...options
    };
    $[1] = options;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useQuery(t1);
};
function _temp(page) {
  return page.list;
}
function _temp2(lastPage, allPages) {
  const totalFetchedItems = allPages.flatMap(_temp).length;
  if (totalFetchedItems < lastPage.page.total) {
    const nextPage = allPages.length + 1;
    return nextPage;
  }
}
function _temp3(page_0) {
  return page_0.list ?? [];
}
function _temp4(data) {
  return {
    pages: data?.pages.flatMap(_temp3),
    pageParams: data.pageParams,
    total: data?.pages.length > 0 ? data?.pages[0].page.total : 0
  };
}
function _temp5(requestParams) {
  return fetchCancelBlock(requestParams);
}
function _temp6(addBlockParams) {
  return addBlock(addBlockParams);
}
function _temp7() {
  return fetchBlockWordList({
    type: "caption"
  });
}